module.exports = __webpack_public_path__ + "static/media/background2.2a708059.png";